import type { RouteRecordRaw } from 'vue-router'

// Content 模块子页（音乐 / 收藏 / 专辑 / 搜索）
export const contentRoutes: RouteRecordRaw[] = [
  {
    path: '/content/music',
    name: 'content-music',
    component: () => import('@/pages/Content/Music/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/content/favorites',
    name: 'content-favorites',
    component: () => import('@/pages/Content/Favorites/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/content/favorites/default',
    name: 'content-favorites-default',
    component: () => import('@/pages/Content/Favorites/Default/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/content/album/:id',
    name: 'content-album',
    component: () => import('@/pages/Content/Album/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/content/search',
    name: 'content-search',
    component: () => import('@/pages/Content/Search/index.vue'),
    meta: { backMode: 'allow' },
  },
]
